import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class TipoPagoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  GetByTipoPago(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query{
          tipo_pago {
            listaTipoPago {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_pago.listaTipoPago
        callback({ mensajes, respuesta })
      }
    );
  }
}
